module.exports = __webpack_public_path__ + "static/media/Apartment-3@2x.668bd694.png";